import request from '@/utils/request'

export function getBankInfoStatus(params) {
  return request({
    url: '/api/v1/teachers/getBankInfoStatus',
    method: 'get',
    params
  })
}
export function getFinanceRecords(params) {
  return request({
    url: '/api/v1/teachers/getFinanceRecords',
    method: 'get',
    params
  })
}
export function getBankInfo(params) {
  return request({
    url: '/api/v1/teachers/getBankInfo',
    method: 'get',
    params
  })
}
export function saveBasicBankInfo(data) {
  return request({
    url: '/api/v1/teachers/saveBasicBankInfo',
    method: 'post',
    data
  })
}
export function saveBankInfo(data) {
  return request({
    url: '/api/v1/teachers/saveBankInfo',
    method: 'post',
    data
  })
}
export function applyWithdraw(data) {
  return request({
    url: '/api/v1/teachers/applyWithdraw',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/payment.js